<template>
  <div>
    <apexchart type="bar" height="200" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

const WEEKDAYS = [
  { iso: 1, label: `Lundi`, shortLabel: `Lun` },
  { iso: 2, label: `Mardi`, shortLabel: `Mar` },
  { iso: 3, label: `Mercredi`, shortLabel: `Mer` },
  { iso: 4, label: `Jeudi`, shortLabel: `Jeu` },
  { iso: 5, label: `Vendredi`, shortLabel: `Ven` },
  { iso: 6, label: `Samedi`, shortLabel: `Sam` },
  { iso: 7, label: `Dimanche`, shortLabel: `Dim` },
];

export default {
  name: `StatisticsByWeekdayChart`,

  props: {
    interventions: Array,
  },

  data: () => ({
  }),

  computed: {
    byWeekdayInterventions() {
      const byWeekdayInterventions = {};

      this.interventions.forEach(intervention => {
        const weekday = moment(intervention.createdAt).format(`E`);
        if (!byWeekdayInterventions[weekday]) {
          byWeekdayInterventions[weekday] = [];
        }
        byWeekdayInterventions[weekday].push(intervention);
      });

      return byWeekdayInterventions;
    },
    byWeekdaySerie() {
      return WEEKDAYS.map(weekday => ({
        ...weekday,
        count: (this.byWeekdayInterventions[weekday.iso] || []).length,
      }));
    },

    series() {
      return [{
        name: `Interventions`,
        data: _.map(this.byWeekdaySerie, `count`),
      }];
    },
    chartOptions() {
      return {
        chart: {
          type: `bar`,
          height: 200,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        title: {
          text: `Jours de la semaine`,
        },
        colors: [`#008ffb`],
        xaxis: {
          categories: _.map(this.byWeekdaySerie, `shortLabel`),
        },
        legend: {
          horizontalAlign: `left`,
        },
      };
    },
  },
};
</script>

<style lang="scss">
</style>
